import vue from 'vue'
import { Page } from '@/page'
import index from './index.vue'
import Exposure from '@/plugins/exposure'

sa.setCurrentPage('首页')
sa.clickNavBar('首页')

vue.use(Exposure)

Page('index', {
  el: '#app',
  template: '<index />',
  components: {
    index
  }
})



// WEBPACK FOOTER //
// ./static/app-index-V4/index.js